export default "__VITE_ASSET__ClaDZ$0M__"